export default {
  gewerbe: {
    kompexplus: {
      label: 'Firmen-Vertrags-Rechtsschutz',
      info: {
        title: null,
        content: `<strong>Firmen-Vertrags-Rechtsschutz</strong> für Streitigkeiten 
        aus Vertrags- und Sachenrecht 
        (Kauf-, Werk-, Wartungs-, Reparatur-, Finanzierungsverträge)
        und für Streitigkeiten aus Verträgen mit Kunden und Lieferanten.`
      },
      privat: false,
      productKey: 'SPEZ-T',
      disabled: false
    },
    ssr: {
      label: 'Spezial-Straf-Rechtsschutz',
      info: {
        title: null,
        content: 'Als Zusatzbaustein kann der Spezial-Straf-Rechtsschutz für den privaten und gewerblichen Bereich abgeschlossen werden. Die Selbstbeteiligung beträgt 0 € im gewerblichen Bereich, im privaten Bereich gilt die Selbstbeteiligung des Hauptvertrages.'
      },
      privat: false,
      productKey: 'SPEZ-SSRG',
      disabled: false
    },
    kompeximmo: {
      label: 'Gewerblicher Immobilien-Rechtsschutz für verpachtete Immobilien',
      info: {
        title: null,
        content: 'Erforderlich, wenn der Gewerbetreibende Verpächter oder Vermieter eines gewerblichen Objektes ist. Diese Auswahl ist nur möglich, wenn auch das selbstgenutzte gewerbliche Objekt versichert ist.'
      },
      privat: false,
      productKey: 'MIETZ',
      disabled: true
    }
  },
  privat: {
    privcyber: {
      label: 'Cyber-Rechtsschutz',
      info: {
        title: null,
        content: `Der Cyber-Rechtsschutz für den privaten Bereich enthält folgende Leistungen:
                  Schadensersatz- und Unterlassungs-Rechtsschutz, Beratungs-Rechtsschutz beim Vorwurf privater Urheberrechtsverletzungen im Internet,
                  Straf-Rechtsschutz. Feste Selbstbeteiligung 150 €. Keine Wartezeit.
                  Als Assistenzleistungen psychologische Soforthilfe nach Cyber-Mobbing und Monitoring persönlicher Daten im Internet.
                  `
      },
      privat: true,
      productKey: 'SPEZ-PRIVCYBER'
    },
    privprestige: {
      label: 'Erweiterung PRESTIGE',
      info: { 
        title: null,
        content: 'Selbstbeteiligung analog Hauptvertrag (privater Bereich)'
      },
      privat: true,
      productKey: 'SPEZ-PRIVPRESTIGE'
    },
    privssr: {
      label: 'Erweiterung Spezial-Straf-Rechtsschutz im privaten Bereich',
      privat: true,
      productKey: 'SPEZ-PRIVSSR'
    },
    privzw: {
      label: 'Rechtsschutz für weitere Ferienwohnung',
      privat: true,
      productKey: 'SPEZ-PRIVZW'
    },
    privvm: {
      label: 'Vermietete Wohneinheit(en)',
      info: {
        title: null,
        content: 'Ist Ihr Kunde privat Vermieter, ist die Absicherung des Vermieter-RS erforderlich.'
      },
      privat: true,
      productKey: 'SPEZ-PRIVVM'
    }
  }
};
